import Dexie, { type Table } from "dexie";

export interface Character {
	id: string;
	script: string;
	character: string;
	meaning: string;
	readings?: string[];
	order?: number;
	description?: string;
	comparisonNote?: string;
}

export interface Sentence {
	id: string;
	script: string;
	sentence: string;
	translation: string;
	characters: string[];
	difficulty: number;
}

export interface Review {
	id?: number;
	itemId: string;
	itemType: "character" | "sentence";
	script: string;
	easeFactor: number;
	interval: number;
	repetitions: number;
	nextReview: string;
	lastReview: string;
	// FSRS fields (populated only when srsMethod === "fsrs")
	srsMethod?: "sm2" | "fsrs";
	stability?: number;
	difficulty?: number;
	fsrsState?: number; // 0=New, 1=Learning, 2=Review, 3=Relearning
	lapses?: number;
	elapsedDays?: number;
	scheduledDays?: number;
}

export interface Session {
	id?: number;
	script: string;
	date: string;
	cardsReviewed: number;
	timeSpent: number;
}

export interface SyncState {
	script: string;
	lastSync: string;
	pendingChanges: boolean;
}

export interface ScriptMeta {
	id: string;
	v: number;
}

export class GrafemDB extends Dexie {
	characters!: Table<Character>;
	sentences!: Table<Sentence>;
	reviews!: Table<Review>;
	sessions!: Table<Session>;
	syncState!: Table<SyncState>;
	scriptMeta!: Table<ScriptMeta>;

	constructor() {
		super("GrafemDB");

		this.version(1).stores({
			characters: "id, script",
			sentences: "id, script, difficulty",
			reviews: "++id, itemId, script, [script+nextReview], nextReview",
			sessions: "++id, script, date",
			syncState: "script",
		});

		this.version(2).stores({
			scriptMeta: "id",
		});

		this.version(3).stores({
			characters: "id, script",
			sentences: "id, script, difficulty",
			reviews: "++id, itemId, script, [script+nextReview], nextReview",
			sessions: "++id, script, date",
			syncState: "script",
			scriptMeta: "id",
		});
	}
}

export const db = new GrafemDB();
